import { isNil } from 'lodash';
import * as QueueActions from '../queue';
import * as TabCommunicationActions from '../tabCommunication';
import * as NotificationsSelectors from '../../selectors/notifications';
import * as NotificationsActions from '../notifications';
import * as ToastsSelectors from '../../selectors/toasts';
import { RealTimeNotificationsStats } from '../../stats';
import { eventTypes } from '../../stats/eventTypes';
import { ADD, REMOVE } from './types';

export function addToast(notification) {
    return {
        type: ADD,
        payload: notification,
    };
}

export const onToastExpiration = (expiredNotification) => (dispatch) => {
    dispatch(removeToast(expiredNotification));
    dispatch(NotificationsActions.removeNotification(expiredNotification));
    dispatch(emit());
};

export const emit = () => (dispatch, getState) => {
    if (ToastsSelectors.isFull(getState())) {
        return;
    }

    const notificationId = dispatch(QueueActions.dequeue());

    if (isNil(notificationId)) {
        return;
    }

    const notification = NotificationsSelectors.getNotificationById(getState(), notificationId);
    dispatch(addToast(notification));
    dispatch(TabCommunicationActions.markNotificationAsConsumed(notificationId));

    RealTimeNotificationsStats.count(eventTypes.NOTIFICATION_TOAST_EMITTED);
};

export function removeToast(notification) {
    return {
        type: REMOVE,
        payload: notification,
    };
}
